import { HomeOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, Layout, Space } from 'antd';
import { Content, Header } from 'antd/es/layout/layout';
import { useEffect, useRef, useState } from 'react';
import { getComponentConfigCConfigPart, NamespacedCCParts, saveComponentConfigCConfigPart } from "../../apis/mgmt/api";
import { NamespacedCCPartsListForm } from '../cconfig/NamespacedCCPartsListForm';
import { EditableProps } from '../common/Editable';
import { ListProps, useStatefulList } from '../common/List';
import { Identifiable } from '../common/Identifiable';


export const FormWithConfig = function<T extends Identifiable> (
    props: {
        formClass: (props: EditableProps<T>) => JSX.Element,
        formProps: EditableProps<T>,
        platformDomain?: string,
        domain?: string,
        platform?: string,
        namespaces: string,
    }
) {
    
    const { platformDomain, domain, platform, namespaces } = props;
    const id = props.formProps.data?.id;
        
    const [ selectedTab,setSelectedTab ] = useState("scope");
    useEffect(() => { setSelectedTab('scope'); }, [id]);
    const selectedTabStyle = (tab: string) => selectedTab===tab? {} : {'display': 'none'};

    const namespacedCCPartsList = useStatefulList<NamespacedCCParts>(undefined, (data) => {
        if (!data.namespace) throw new Error('Namespace is required');
        return data.namespace       
    });

    const namespacedCCPartsListRef = useRef<ListProps<NamespacedCCParts>>(namespacedCCPartsList);
    useEffect(() => { namespacedCCPartsListRef.current = namespacedCCPartsList; }, [namespacedCCPartsList]);
    useEffect(() => {
        if (!id || !platformDomain || !domain || !platform || !namespaces) return;
        getComponentConfigCConfigPart(domain, platform, platformDomain, namespaces).then((response) => {
            if (response.status !== 200) {
                throw new Error('Error getting component config part');
            }
            namespacedCCPartsListRef.current.setData(response.data);
        });
    }, [ id , platformDomain , domain , platform , namespaces ]);
    useEffect(() => {
        return props.formProps.addOnSavedHandler((savedData: T, hideAfterSaving: boolean) => {
            if (!id || !platformDomain || !domain || !platform || !namespaces) return;
            saveComponentConfigCConfigPart(
                domain, platform, platformDomain,
                namespacedCCPartsListRef.current.data || []
            ).then((response) => {
                if (response.status !== 200) {
                    throw new Error('Error saving component config part');
                }
                namespacedCCPartsListRef.current.setData(response.data);
            });
        });
    }, [ id , platformDomain , domain , platform , namespaces ]);

    return (
        <Layout className="h-100" >
        <Header style={{'paddingBottom': '1em'}}>
        <Space.Compact direction="horizontal" >
            <Button type="text" onClick={()=>setSelectedTab('scope')}><HomeOutlined />Principal</Button>
            <Button type="text" onClick={()=>setSelectedTab('config')} disabled={!id}><SettingOutlined />Configuración</Button> 
        </Space.Compact>
        </Header>
        <Content className="h-100">
            <div style={selectedTabStyle('scope')} className="h-100">
                <props.formClass {...props.formProps} />
            </div><div style={selectedTabStyle('config')} className="h-100">
                <NamespacedCCPartsListForm {...namespacedCCPartsList} />
            </div>
        </Content>
        </Layout>
    );

};
